export const transform = (value) => {
    return `
    &:hover {
        transform: scale(${value});
    }
`;
};
